<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { SCIcon } from '@nsftx/seven-components'
import { useWalletBalanceStore } from '@/stores/wallet/walletBalanceStore'

// const
const walletBalanceActionIcons = {
  show: 'n-i-eye-b',
  hide: 'n-i-eye-c'
}

// stores
const walletBalanceStore = useWalletBalanceStore()
const { isWalletBalanceVisible } = storeToRefs(walletBalanceStore)
const { toggleWalletBalanceVisibility } = walletBalanceStore

// computeds
const walletBalanceActionIcon = computed(
  () => walletBalanceActionIcons[isWalletBalanceVisible.value ? 'show' : 'hide']
)

// methods
const toggleBalanceVisibility = () => {
  toggleWalletBalanceVisibility()
}
</script>

<template>
  <div
    class="st-wallet-balance-visibility-toggle st-flex-center-center sc-p-4"
    @click="toggleBalanceVisibility"
  >
    <SCIcon :icon="walletBalanceActionIcon" size="xl" color="var(--sc-text-primary-1)" />
  </div>
</template>

<style lang="scss" scoped>
.st-wallet-balance-visibility-toggle {
  border: 1px solid var(--sc-theme-100);
  border-radius: 4px;
}
</style>
